import { NotFoundError, createValidationSchema, passwordField, isError, runUnsafe, PosixDate, InvalidCredentialsError, } from "@for-it/domain-lib";
import { UserEntity } from "../../entities/user.js";
export const changePassword = {
    name: "changePassword",
    description: "Changes the user's password with a new one after verifying the current password.",
    type: "command",
    payloadSchema: createValidationSchema({
        password: passwordField({
            required: true,
            message: "Password field is required",
        }),
        newPassword: passwordField({
            required: true,
            message: "NewPassword is required",
        }),
    }),
    isAuthRequired: true,
    useCase: async ({ currentUser, db, crypto }, { password, newPassword }) => {
        const user = await db.findOneBy(UserEntity, {
            id: currentUser.id,
        });
        if (!user) {
            return new NotFoundError();
        }
        const passwordResult = await crypto.assertValidPassword(password, user.hashedPassword);
        if (isError(passwordResult)) {
            return new InvalidCredentialsError();
        }
        const updatedUser = {
            ...user,
            hashedPassword: await runUnsafe(crypto.hashPassword(newPassword)),
            updatedAt: new PosixDate(Date.now()),
        };
        await db.update(UserEntity, user.id, updatedUser);
    },
};
